var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 1.99996H13C13.1769 1.99996 13.3464 2.0702 13.4714 2.19522C13.5965 2.32025 13.6667 2.48981 13.6667 2.66663V13.3333C13.6667 13.5101 13.5965 13.6797 13.4714 13.8047C13.3464 13.9297 13.1769 14 13 14H1.00004C0.82323 14 0.65366 13.9297 0.528636 13.8047C0.403612 13.6797 0.333374 13.5101 0.333374 13.3333V2.66663C0.333374 2.48981 0.403612 2.32025 0.528636 2.19522C0.65366 2.0702 0.82323 1.99996 1.00004 1.99996H3.66671V0.666626H5.00004V1.99996H9.00004V0.666626H10.3334V1.99996ZM1.66671 5.99996V12.6666H12.3334V5.99996H1.66671ZM3.00004 7.33329H4.33337V8.66663H3.00004V7.33329ZM6.33337 7.33329H7.66671V8.66663H6.33337V7.33329ZM9.66671 7.33329H11V8.66663H9.66671V7.33329Z",
    fill: "#0F62FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlue);
export default __webpack_public_path__ + "static/media/calendar-blue.8ff9c82071e7a02e112cc4c5ce844952.svg";
export { ForwardRef as ReactComponent };